import * as React from "react";
import { TwitterShareButton } from 'react-twitter-embed';

import CircularProgress from "@material-ui/core/CircularProgress"
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";

import {Button, GithubInvite, Text} from "../components";

import thankyou from "./thank-you.svg";

type ClassNames = "actions" | "title" | "link" | "emoji" | "twitter" | "content" | "thankyou";
const styles = (theme: Theme): StyleRules<ClassNames> => ({
  actions: {
    marginRight: theme.spacing.unit * 3
  },
  title: {
    paddingLeft: 0
  },
  link: {
    color: theme.typography.body1.color
  },
  emoji: {
    color: "black"
  },
  twitter: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2
  },
  content: {
    textAlign: "center"
  },
  thankyou: {
    width: 200,
    height: "auto"
  }
});

export type CheckoutStatus = "none" | "loading" | "error" | "success"

interface ICoffeeCheckoutDialogProps extends WithStyles<typeof styles>  {
  accessKey: string | null;
  email: string | null;
  checkout: CheckoutStatus;
  onClose: () => void;
  onCloseError: () => void;
}

class CoffeeCheckoutDialog extends React.PureComponent<ICoffeeCheckoutDialogProps> {

  public render() {
    const {checkout, classes, accessKey, email} = this.props;
    if (checkout === "loading") {
      return (
        <Dialog open={true}>
          <DialogContent>
              <CircularProgress />
          </DialogContent>
        </Dialog>
      )
    }
    if (checkout === "success") {
      return (
        <Dialog open={true} onClose={this.props.onClose} onBackdropClick={this.props.onClose}>
          <DialogContent className={classes.content}>
              <img src={thankyou} className={classes.thankyou} />
            <DialogTitle className={classes.title}>Thank you for your support</DialogTitle>
            <Text>
            Thank you for supporting the series.  <span className={classes.emoji}>☕️📺</span>
            You can add your GitHub username below and I will add you to the private repository where I tinker with the examples we use in the series.
            Please <a href="mailto:wcandillon@gmail.com" className={classes.link}>contact me</a> if you have any questions.
            </Text>
            <div className={classes.twitter}>
              <TwitterShareButton
                url="https://react-native.shop/buy-me-a-coffee"
                options={{ size: "large", text: `I just bought a coffee to @wcandillon for the “Can it be done in React Native?” YouTube series.` }}
              />
            </div>
            {
              (accessKey && email) && (
                <GithubInvite
                  repo="can-it-be-done-in-react-native-private"
                  {...{accessKey, email}}
                />
              )
            }
          </DialogContent>
        </Dialog>
      )
    }
    if (checkout === "error") {
      return (
        <Dialog open={true} onClose={this.props.onCloseError}>
          <DialogContent>
            <DialogTitle className={classes.title}>Thank you for your support <span className={classes.emoji}>❤️</span></DialogTitle>
            <Text>
            Thank you for supporting the series. <span className={classes.emoji}>☕️📺</span>
            Unfortunately an error happened while processing the payment. <span className={classes.emoji}>🤷🏼‍♂️</span>
            Please <a href="mailto:wcandillon@gmail.com" className={classes.link}>contact me</a> if you have any questions.
            </Text>
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button onClick={this.props.onCloseError} primary={true}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      )
    }
    return null;
  }
}

export default withStyles(styles)(CoffeeCheckoutDialog);


// WEBPACK FOOTER //
// ./src/buy-me-a-coffee/CoffeeCheckoutDialog.tsx